import { render, staticRenderFns } from "./tm-messages-page.vue?vue&type=template&id=58228079&scoped=true&"
import script from "./tm-messages-page.vue?vue&type=script&lang=ts&"
export * from "./tm-messages-page.vue?vue&type=script&lang=ts&"
import style0 from "./tm-messages-page.vue?vue&type=style&index=0&id=58228079&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58228079",
  null
  
)

export default component.exports